module.exports = __webpack_public_path__ + "static/media/warning.ef85bf19.svg";